import moment from 'moment'
import React, { useEffect, useState } from 'react'
import DatePicker, { CalendarContainer, setHours, setMinutes } from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.min.css";
import { id } from "date-fns/locale";
import { getDateViewFromMysql, getStrDateForMysql } from 'utils/MyUtils';

const DatepickerMy = (props) => {
    const { name, renderFunc, validation, setValue, register, handleSubmit, watch, control, value = "", className, icon, error, label, placeholder, mb = "3", ...rest } = props
    const [mydate, setMyDate] = useState();
    const pholder = placeholder === " " ? label : placeholder



    const MyContainer = ({ className, children }) => {
        return (
            <div style={{ padding: "2px", background: "#007bff", color: "#fff" }}>
                <CalendarContainer className={className}>
                    <div style={{ position: "relative" }}>{children}</div>
                </CalendarContainer>
            </div>
        );
    };

    useEffect(() => {
        if (moment(value).isValid()) {
            const val = getStrDateForMysql(value)
            const dateval = getDateViewFromMysql(val)
            setValue(name, val)
            setMyDate(dateval)
        } else {
            setValue(name, "")
            setMyDate(null)
        }
    }, [value])

    return (
        <div className={`${icon ? "input" : "form"}-group mb-${mb}`}>
            {label && <label>{label}</label>}

            <DatePicker
                {...register(name, { ...validation })}
                showMonthDropdown
                showYearDropdown
                //showTimeSelect
                className={`form-control ${error ? "is-invalid" : ""} 
                ${className}`}
                placeholderText={pholder}
                selected={mydate}
                locale={id}
                onChange={(date) => {
                    setMyDate(date)
                    if (moment(date).isValid()) {
                        setValue(name, getStrDateForMysql(date))
                    } else {
                        setValue(name, "")
                    }
                }}
                //calendarContainer={MyContainer}
                //popperPlacement="top-start"
                {...rest}
            />
            {icon && <div className="input-group-append">
                <div className="input-group-text">
                    <span className={`fas ${icon}`} />
                </div>
            </div>}

            {error && <span className="text-danger">{error}</span>}
        </div>
    )
}

DatepickerMy.defaultProps = {
    register: () => { },
    setValue: () => { },
    name: "",
    validation: {},
    className: "",
    error: "",
    label: "",
    placeholder: " ",
    dateFormat: "dd/MM/yyyy",
    timeIntervals: 15,
}
export default DatepickerMy

/*import moment from 'moment'
import React, { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import { getDateViewFromMysql } from 'utils/MyUtils';

const DatepickerMy = (props) => {
    const { name, validation, renderFunc, setValue, register, handleSubmit, watch, control, value = "", className, icon, error, label, placeholder, mb = "3", ...rest } = props
    const [mydate, setMyDate] = useState();
    const pholder = placeholder === " " ? label : placeholder

    useEffect(() => {
        setMyDate(value)
        if (moment(value).isValid()) {
            setValue(name, moment(value).utc(true).format("YYYY-MM-DD"))
        } else {
            setValue(name, "")
        }
    }, [value])

    return (
        <div className={`${icon ? "input" : "form"}-group mb-${mb}`}>
            {label && <label>{label}</label>}

            <DatePicker
                {...register(name, { ...validation })}
                showMonthDropdown
                showYearDropdown
                className={`form-control ${error ? "is-invalid" : ""} 
                ${className}`}
                placeholderText={pholder}
                selected={mydate}
                onChange={(date) => {
                    setMyDate(date)
                    if (moment(date).isValid()) {
                        setValue(name, moment(date).utc(true).format("YYYY-MM-DD"))
                    } else {
                        setValue(name, "")
                    }
                }}
                {...rest}
            />
            {icon && <div className="input-group-append">
                <div className="input-group-text">
                    <span className={`fas ${icon}`} />
                </div>
            </div>}

            {error && <span className="text-danger">{error}</span>}
        </div>
    )
}

DatepickerMy.defaultProps = {
    register: () => { },
    setValue: () => { },
    name: "",
    validation: {},
    className: "",
    error: "",
    label: "",
    placeholder: " ",
    dateFormat: "dd/MM/y"
}
export default DatepickerMy
*/
